<template>
  <div class="print">
    <div class="no-print">
      <v-card max-width="400px">
        <v-card-title>
          <h4>Impresion Cheque</h4>
        </v-card-title>
        <v-card-text>
          <v-text-field
            type="number"
            v-model="talonario"
            label="Nro Talonario"
          />
          <v-text-field type="number" v-model="desde" label="Nro Desde" />
          <v-text-field type="number" v-model="hasta" label="Nro Hasta" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="info" @click="$router.back()" >Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="leer">LEER</v-btn>
          <v-btn @click="imprimir" :disabled="cheques.length == 0"
            >IMPRIMIR</v-btn
          >
        </v-card-actions>
      </v-card>
      <div v-if="cheques.length > 0">
        <h1 class="text-h6">Se encontraron {{ cheques.length }} cheques</h1>

        <h1 class="text-h6 mt-3">ATENCION! ANTES DE IMPRIMIR RECUERDE</h1>
        <h3 class="text-subtitle-1">
          <ul>
            <li>Seleccionar la impresora (Matricial)</li>
            <li>
              Selccionar el tamaño de la hoja CHEQUE (22cm de ancho x 7.6cm de
              alto)
            </li>
            <li>Configurar Margenes a (Ninguno)</li>
            <li>Escala: tamaño real (100%)</li>
            <li>Imprimir encabezados y pies de página (NO)</li>
          </ul>
        </h3>
      </div>
    </div>
    <div class="print hide">
      <div v-for="(c, index) in cheques" :key="c.numeroCheque" :class="{pagebreak: index > 0}">
        {{ index+1 }}/{{ cheques.length }}
        <div class="talon-numero-cheque">{{ c.numeroCheque }}</div>
        <div class="talon-fecha">{{ c.fecha | dateFormat }}</div>
        <div class="talon-numero-op">OP # {{ c.numeroOp }}</div>
        <div class="talon-alaorden">{{ c.alaOrden }}</div>
        <div class="talon-monto">{{ c.importe | numberFormat }}</div>
        <div class="cheque-monto">{{ c.importe | numberFormat }}</div>
        <div class="cheque-dia">{{ c.fecha | dateFormatDay }}</div>
        <div class="cheque-mes">{{ c.fecha | dateFormatMonth }}</div>
        <div class="cheque-anio">{{ c.fecha | dateFormatYear }}</div>
        <div class="cheque-texto">{{ c.textoCheque }}</div>
        <div class="cheque-alaorden">{{ c.alaOrden }}</div>

        <!-- <div class="">.</div> -->

      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import numeral from "numeral";

export default {
  // components: { FotoUpload },
  data() {
    return {
      loading: false,
      talonario: 5,
      desde: 307773,
      hasta: 307779,
      cheques: [],
    };
  },
  mounted() {},
  methods: {
    leer() {
      axios
        .get("/pago/reporteCheques", {
          params: {
            talonario: this.talonario,
            desde: this.desde,
            hasta: this.hasta,
          },
        })
        .then((response) => {
          console.log(response);
          this.cheques = response.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.errorMessage = err.response.data;
        });
    },
    // calculateAge(birthday) { // birthday is a date
    //   const ageDifMs = Date.now() - birthday;
    //   const ageDate = new Date(ageDifMs); // miliseconds from epoch
    //   return Math.abs(ageDate.getUTCFullYear() - 1970);
    // },
    // selectFile() {
    //   console.log('select file', this.$refs)
    //   console.log('select file', this.$refs.fileSelector.click())
    // },
    imprimir() {
      window.print();
    },
  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    dateFormatDay(value) {
      if (value) {
        return moment(String(value)).format("DD");
      }
    },
    dateFormatMonth(value) {
      if (value) {
        return moment(String(value)).format("MM");
      }
    },
    dateFormatYear(value) {
      if (value) {
        return moment(String(value)).format("YY");
      }
    },
    numberFormat(value) {
      if (!value) {
        return numeral(0).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
      if (value) {
        return numeral(value).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
};
</script>

<style scoped>
@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
  .print {
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
  }
  .pagebreak {
    page-break-inside: avoid;
    page-break-before: always;
    position: relative;
  }
}

.hide {
  display: none;
}

div {
  /* font-family: "Courier New", Courier, monospace; */
  font-family: "arial", "times", "sans-serif";
  font-size: 15px;
}

div.talon-numero-cheque {
  position: absolute;
  top: 0.6cm;
  left: 1cm;
  width: 3.5cm;
  height: 20px;
  text-align: right;
  overflow: hidden;
}

div.talon-fecha {
  position: absolute;
  top: 1.2cm;
  left: 1.5cm;
  width: 3cm;
  height: 16px;
  text-align: right;
  overflow: hidden;
}
div.talon-alaorden {
  position: absolute;
  top: 1.8cm;
  left: 0.8cm;
  width: 3.7cm;
  height: 20px;
  font-size: 8px;
  text-indent: 1.5cm;
}
div.talon-numero-op {
  position: absolute;
  top: 3cm;
  left: 0.8cm;
  width: 3.7cm;
  text-align: right;
  height: 16px;
}
div.talon-monto {
  position: absolute;
  top: 5.5cm;
  left: 1cm;
  width: 3.5cm;
  height: 20px;
  font-size: 16px;
  text-align: right;
  /* border: 0.5px solid black; */
  /* font-weight: bold; */
}

div.cheque-monto {
  position: absolute;
  top: 0.4cm;
  left: 17.5cm;
  width: 4cm;
  height: 20px;
  font-size: 16px;
  text-align: right;
  /* font-weight: bold; */
}

div.cheque-dia {
  position: absolute;
  top: 1.6cm;
  left: 13.3cm;
  width: 0.5cm;
  height: 20px;
  font-size: 16px;
  /* font-weight: bold; */
}

div.cheque-mes {
  position: absolute;
  top: 1.6cm;
  left: 14.9cm;
  width: 0.5cm;
  height: 20px;
  font-size: 16px;
  /* font-weight: bold; */
}

div.cheque-anio {
  position: absolute;
  top: 1.6cm;
  left: 16.3cm;
  width: 0.5cm;
  height: 20px;
  font-size: 16px;
  /* font-weight: bold; */
}

div.cheque-alaorden {
  position: absolute;
  top: 2.3cm;
  left: 8.3cm;
  width: 13.2cm;
  height: 20px;
  font-size: 16px;
  overflow: hidden;
  /* border: 1px solid black; */
  /* font-weight: bold; */
}

div.cheque-texto {
  position: absolute;
  top: 3cm;
  left: 5cm;
  width: 16.5cm;
  height: 20px;
  font-size: 16px;
  text-indent: 3.3cm;
  line-height: 22px;
  /* border: 1px solid black */
  /* font-weight: bold; */
}

</style>